import React, { useEffect, useState } from "react";
import { FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import endPoint from "../redux/EndPoint/endpoint";
import axios from "axios";

const HeaderBrand = () => {
  const navigate = useNavigate();
  const [startIndex, setStartIndex] = useState(0);
  const itemsPerPage = 4;
  const [showAllBrand, setShowAllBrand] = useState([]);

  useEffect(() => {
    const getBrand = async () => {
      try {
        const res = await axios.get(endPoint.GetBrandWeb);
        setShowAllBrand(res.data);
      } catch (error) {
        console.error("Error fetching brand data:", error.message);
      }
    };
    getBrand();
  }, []);

  const handleViewAllBrands = () => {
    navigate("/ViewAllBrand");
  };

  const visibleCategories = showAllBrand?.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handleNext = () => {
    if (startIndex + itemsPerPage < showAllBrand?.length) {
      setStartIndex(startIndex + itemsPerPage);
    }
  };

  const handlePrevious = () => {
    if (startIndex - itemsPerPage >= 0) {
      setStartIndex(startIndex - itemsPerPage);
    }
  };

  const _handleClick = (name) => {
    const url = `/brand/${name.name}/${name._id}`;
    navigate(url);
  };

  return (
    <>
      <div className="flex justify-center items-center z-50 self-center mt-3">
        <div className="flex gap-3 sm:gap-3 overflow-x-auto w-full self-center justify-center items-center">
          <div className="w-[90%] self-center items-center justify-center flex bg-gray-100 to-white  bg-gray-10 pb-3">
            <div className="sm:hidden  flex flex-col w-[100%] bg-gray-100 relative">
              <h1 className="text-black m-2 text-lg font-bold">Brands</h1>
              <div className="flex flex-row  items-center justify-center ">
                {startIndex > 0 && (
                  <button
                    onClick={handlePrevious}
                    className="z-10 fixed  flex left-[-13px] h-20 w-10 justify-center items-center"
                  >
                    <button className="  text-blue-500 font-medium text-sm flex items-center h-8 w-8 rounded-full justify-center bg-gray-300">
                      <FaChevronRight className="rotate-180" />
                    </button>
                  </button>
                )}

                {visibleCategories?.map((category, index) => (
                  <div
                    key={index}
                    className="relative flex flex-col items-center cursor-pointer  w-96 overflow-hidden"
                    onClick={(e) => {
                      e.stopPropagation();
                      _handleClick(category);
                    }}
                  >
                    <img
                      src={category.image}
                      alt={category.name}
                      className="w-14 h-14 rounded-full object-cover mb-2"
                    />
                    <button className="text-black font-medium hover:text-red-700 text-sm sm:text-base whitespace-nowrap overflow-hidden text-ellipsis  w-[95%]">
                      {category.name}
                    </button>
                  </div>
                ))}

                {startIndex + itemsPerPage < showAllBrand?.length && (
                  <button
                    className="absolute right-[-13px] text-blue-500 font-medium text-sm flex items-center  h-8 w-8 rounded-full justify-center bg-gray-300"
                    onClick={handleNext}
                  >
                    <FaChevronRight />
                  </button>
                )}
              </div>
            </div>
            <div className=" hidden sm:flex flex-row overflow-x-auto gap-10 items-center bg-transparent p-3">
              {showAllBrand?.slice(0, 12).map((category, index) => (
                <div
                  key={index}
                  className="relative flex flex-col items-center cursor-pointer mt-3"
                  onClick={(e) => {
                    e.stopPropagation();
                    _handleClick(category);
                  }}
                >
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-12 h-12 rounded-full object-cover mb-2"
                  />
                  <button
                    className="text-black font-medium hover:text-red-700 text-sm sm:text-base 
                  whitespace-nowrap overflow-hidden text-ellipsis"
                  >
                    {category.name}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-between items-center w-[90%] mx-auto hidden sm:flex  py-1">
        <h2 className="text-lg font-semibold"></h2>
        <button
          onClick={handleViewAllBrands}
          className="flex  text-blue-500 font-medium text-sm sm:text-base items-center"
        >
          View All Brands
          <FaChevronRight className="ml-2" />
        </button>
      </div>
    </>
  );
};

export default HeaderBrand;
